export default __webpack_public_path__ + "static/media/arrow-up.inline.d7954b02.svg";